import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";

const AiGuidelines= ({ isOpen, onClose, alert, label, view }) => {
  if (!isOpen || !alert) return null;
console.log(alert)
  const isGuideline = alert?.guideline_reference && view === 1;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-xl rounded-lg shadow-lg relative p-6 text-center">
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none"
          onClick={onClose}
          aria-label="Close modal"
        >
          <FontAwesomeIcon icon={faTimes} className="text-lg" />
        </button>

          <>
            <h2 className="text-lg font-semibold text-blue-700 mb-3 border-b pb-2 text-start">
              {label ? `${label} Result` : alert?.label ? `${alert.label} Alert` : ''}
            </h2>

            <p className="text-gray-900 text-sm font-bold text-start">{alert?.label || alert?.test}</p>

            {alert?.type && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">{label}</p>
       
              </div>
            )}

            {alert?.alert?.recommendation||alert?.alert?.item && (
              <div className="mb-2 flex flex-col gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Full Recommendation::</p>
                <p className="text-gray-900 text-sm">{alert?.alert?.recommendation||alert?.alert?.item}</p>
              </div>
            )}

            {!alert?.type && !alert?.text && alert?.risk && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Full Description:</p>
                <p className="text-gray-900 text-sm">{alert?.risk}</p>
              </div>
            )}

            {!alert?.type && !alert?.text && !alert?.risk && (
              <div className="mb-2 flex items-center gap-1 text-start">
                <p className="text-gray-900 text-sm font-bold">Current Value:</p>
                <p className="text-gray-900 text-sm">{alert?.value || alert?.result}</p>
              </div>
            )}

            {alert?.alert?.guideline_reference && (
              <div className="bg-gray-50 p-4 rounded-md border border-gray-200 mt-2 text-start">
                <p className="text-gray-900 text-sm font-bold mb-1">📖 Guideline Reference</p>
                <p className="text-gray-900 text-sm font-bold mb-2">
                  {alert?.alert?.guideline_reference.source}
                </p>
                <a
                  href={alert?.alert?.guideline_reference.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 text-sm font-medium underline"
                >
                  View Guidelines →
                </a>
              </div>
            )}
          </>
      
      </div>
    </div>
  );
};

export default AiGuidelines;
